import clsx from 'clsx';

import { Alter25ProductCarousel } from '@/components/alter25/carousel/Alter25ProductCarousel';
import { SwabKitProductDetails } from '@/components/alter25/shop/swab-kit/product-details/SwabKitProductDetails';
import { ShopSwabKitProductReview } from '@/components/alter25/shop/swab-kit/ShopSwabKitProductReview';
import type { GalleryT } from '@/utils/contentfulTypes';

interface ShopSwabKitTopSectionProps {
  swabKitProductGallery: GalleryT;
}

export const ShopSwabKitTopSection: React.FC<ShopSwabKitTopSectionProps> = ({
  swabKitProductGallery,
}) => {
  return (
    <>
      <div
        className={clsx(
          // 'container mx-auto my-10 ',
          'grid lg:grid-cols-2 grid-cols-1 lg:gap-10 gap-4',
          'pb-8 lg:pb-12'
        )}
      >
        <div id="swabKitLeftSide">
          <Alter25ProductCarousel swabKitProductGallery={swabKitProductGallery} />
          <ShopSwabKitProductReview className="hidden lg:block" />
        </div>

        <div id="swabKitRightSide">
          <SwabKitProductDetails />
        </div>
      </div>
    </>
  );
};
